import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EquipmentsService } from './logic/equipments.service';
import { EquipmentsLogicService } from './logic/equipments/equipments-logic.service';
import { EquipmentsDaoService } from './dao/equipments-dao.service';
import { EquipmentsDbDaoService } from './dao/equipments-dao/equipments-db-dao.service';
import { EquipmentDbTableDefinition } from './dao/equipments-dao/equipment-db-table-definition';
import { LocalEquipmentDbTableDefinition } from './dao/equipments-dao/local-equipment-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: EquipmentsService, useClass: EquipmentsLogicService },
    { provide: EquipmentsDaoService, useClass: EquipmentsDbDaoService },
    { provide: EquipmentDbTableDefinition },
    { provide: LocalEquipmentDbTableDefinition },
  ]
})
export class EquipmentsModule {}
